import React from 'react';

export const CardTemplate = ({ heading = '', classNames = '', children, headingClass = '', bodyClass = '' }) => (
    <div className={`${classNames}`}>
        <h4 className={`card-header bg-transparent ${headingClass}`}>{heading}</h4>
        <div className={`card-body ${bodyClass}`}>{children}</div>
    </div>
);
